import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { colors } from '../../../constants/colors';
import { fontSize, fontFamily } from '../../../constants/text';
import EditProfileForm from '../../Account/Profile/EditProfileForm';
import { buildDapiUserProfileObject } from '../../../core/dapi/userProfile';
import { analyticsTrackEvent } from '../../../core/analytics';
import { ADD_PROFILE_CANCEL, ADD_PROFILE_SUBMIT } from '../../../core/analytics/events';
import { biggerThan } from '../../../core/util/styledComponents';

const SmoothDialog = styled(Dialog)`
  -webkit-font-smoothing: antialiased;
  & .dialog-root {
    background-color: ${colors.whiteGrey};

    ${biggerThan.sm`
      padding: 20px 0;
    `}
  }
`;

const Close = styled.div`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 26px;
  top: 20px;
  cursor: pointer;

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.blueMonday};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.blueMonday};
  }
`;

const Header = styled.div`
  color: ${colors.squid};
  font-size: ${fontSize.large};
  font-family: ${fontFamily.bold};
  text-align: center;
  padding-top: 32px;
`;

class AddProfileModal extends PureComponent {
  static propTypes = {
    accountSummary: PropTypes.object,
    closeModal: PropTypes.func,
    createUserProfile: PropTypes.func,
    fullScreen: PropTypes.bool,
    open: PropTypes.bool,
    submitting: PropTypes.bool,
  };

  onFormSubmit = form => {
    analyticsTrackEvent(ADD_PROFILE_SUBMIT);
    this.props.closeModal();

    const userProfileData = {
      ...buildDapiUserProfileObject(form),
      account_id: this.props.accountSummary.id,
      is_verified: true,
      is_hidden: false,
    };
    this.props.createUserProfile(userProfileData);
  };

  handleCancel = () => {
    analyticsTrackEvent(ADD_PROFILE_CANCEL);
    this.props.closeModal();
  };

  render() {
    const { open, fullScreen, closeModal, submitting } = this.props;

    return (
      <SmoothDialog
        open={open}
        closeModal={closeModal}
        maxWidth="sm"
        scroll="body"
        PaperProps={{ classes: { root: 'dialog-root' } }}
        fullScreen={fullScreen}
        fullWidth
        transitionDuration={{ exit: 0 }}
      >
        <Close onClick={closeModal} />
        <Header>Add Family</Header>
        <EditProfileForm
          handleFormSubmit={this.onFormSubmit}
          handleCancel={this.handleCancel}
          showErrors
          submitting={submitting}
        />
      </SmoothDialog>
    );
  }
}

export default withMobileDialog({ breakpoint: 'xs' })(AddProfileModal);
